<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">Lista de Usuarios</p>
    </div>
    <div
      class="row col-12 q-mt-md q-gutter-sm items-center text-brand-5 text-weight-bold"
    >
      <div class="col">
        <div>Unidade</div>
        <SelecaoUnidade
          @enviarUnidade="receberUnidade"
          :model="$store.state.org.unidadeData"
        />
      </div>
      <div class="col">
        <div>GHE</div>
        <q-input dense outlined v-model="filtros.ghe" />
      </div>
      <div class="col">
        <div>Cargo</div>
        <q-input dense outlined v-model="filtros.cargo" />
      </div>
      <div class="col">
        <div>Centro de Custo</div>
        <q-input dense outlined v-model="filtros.centro" />
      </div>
      <div class="col">
        <div>Biometria</div>
        <q-select
          dense
          outlined
          v-model="filtros.biometria"
          :options="options.biometriaOptions"
        />
      </div>
    </div>
    <div class="row col-12 q-mt-md">
      <div>
        <q-btn
          label="Atualizar Biometrias"
          no-caps
          icon="sync"
          color="positive"
          @click="atualizarTemplatesBiometria()"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <q-table
        :columns="columns"
        :rows="listaUsuarios"
        table-header-class="bg-accent text-width-bold"
        class="tabela-tamanho-fixo q-mt-sm"
        row-key="id"
        :loading="disable"
        color="primary"
        flat
        dense
        hide-bottom
        hide-pagination
        v-model:pagination="pagination"
      >
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtros.filtrar"
            type="text"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template v-slot:body-cell-id="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row?.id }}
          </q-td>
        </template>
        <template v-slot:body-cell-name="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row?.name }}
          </q-td>
        </template>
        <template v-slot:body-cell-email="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row?.email }}
          </q-td>
        </template>
        <template v-slot:body-cell-cargo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row?.cargo }}
          </q-td>
        </template>
        <template v-slot:body-cell-function="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row?.function }}
          </q-td>
        </template>
        <template v-slot:body-cell-sap="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row?.sap }}
          </q-td>
        </template>
        <template #body-cell-biometry="props">
          <q-td>
            <div
              style="cursor: pointer"
              @click="(userId = props.row.id), (biometria = !biometria)"
            >
              <q-img
                width="59px"
                heigth="60px"
                v-if="!props.row.biometry"
                src="../../../assets/bioNO.png"
                fit="fill"
              />
              <q-img
                width="59px"
                heigth="60px"
                v-else
                src="../../../assets/bioOK.png"
                fit="fill"
              />
            </div>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-center q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
    <BiometriaTeste
      :modal="biometria"
      :userId="userId"
      :titulo="'Cadastro de Biometria'"
      :tipoBiometria="'cadastro'"
      @atualizarBiometrias="atualizarTemplatesBiometria"
    />
  </q-page>
</template>

<script setup>
import { onMounted, ref, computed, watch } from "vue";
import { useStore } from "vuex";

import SelecaoUnidade from "../../ferramentaria/components/SelecaoUnidade.vue";
import BiometriaTeste from "../../biometria/views/BiometriaTeste.vue";
import { useQuasar } from "quasar";

const columns = ref([
  {
    name: "id",
    label: "ID",
    field: "id",
    align: "left",
  },
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
  },
  {
    name: "email",
    label: "Email",
    field: "email",
    align: "left",
  },
  {
    name: "cargo",
    label: "Cargo",
    field: "cargo",
    align: "left",
  },
  {
    name: "function",
    label: "Processo / Função",
    field: "function",
    align: "left",
  },
  {
    name: "sap",
    label: "ID Usuário",
    field: "sap",
    align: "left",
  },
  {
    name: "tnumber",
    label: "Matricula",
    field: "tnumber",
    align: "left",
  },
  {
    name: "biometry",
    label: "Biometria",
    field: "biometry",
    align: "left",
  },
]);

const store = useStore();
const quasar = useQuasar();

const filtros = ref({
  unidade: "",
  ghe: "",
  cargo: "",
  centroCusto: "",
  filtrar: "",
  biometria: {
    label: "Todos",
    value: "",
  },
});
const options = ref({
  biometriaOptions: [
    {
      label: "Todos",
      value: "",
    },
    {
      label: "Cadastrados",
      value: true,
    },
    {
      label: "Não Cadastrado",
      value: false,
    },
  ],
});
const pagination = ref({
  sortBy: "desc",
  descending: false,
  page: 1,
  rowsPerPage: 10,
  rowsNumber: 15,
});
const disable = ref(false);
const listaUsuarios = ref([]);
const userId = ref("");
const biometria = ref(false);

const receberUnidade = (value) => {
  filtros.value.unidade = value;
};

const listarUsuarios = async (page = 0, perPage = 10) => {
  disable.value = true;
  try {
    const response = await store.dispatch("user/getUsuarios", {
      vendor_id: filtros.value.unidade?.id,
      page,
      per_page: perPage,
      search: filtros.value.filtrar,
      biometria: filtros.value.biometria?.value,
      ghe: filtros.value.ghe,
      cost_center_id: filtros.value.centroCusto,
      cargo: filtros.value.cargo,
    });

    listaUsuarios.value = response.data.results.data;

    pagination.value.page = response.data.results.current_page;
    pagination.value.rowsPerPage = response.data.results.per_page;
    pagination.value.rowsNumber = response.data.results.total;
    disable.value = false;
  } catch (error) {
    disable.value = false;
    console.log(error);
  }
};

const pagesNumber = computed(() =>
  Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
);

watch(
  () => pagination.value.page,
  () => {
    listarUsuarios(pagination.value.page, pagination.value.rowsPerPage);
  }
);

const atualizarTemplatesBiometria = async () => {
  try {
    await store.dispatch("user/atualizarTemplatesBiometria");
    listarUsuarios();
    quasar.notify({
      message: "Atualizando templates de biometria..",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  } catch (error) {
    quasar.notify({
      message: "Erro ao atualizar templates de biometria",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

watch(
  [
    () => filtros.value.filtrar,
    () => filtros.value.unidade,
    () => filtros.value.cargo,
    () => filtros.value.biometria,
    () => filtros.value.ghe,
    () => filtros.value.centroCusto,
  ],
  () => {
    listarUsuarios();
  }
);

onMounted(() => {
  listarUsuarios();
});
</script>

<style scoped>
tbody tr td {
  white-space: pre-wrap;
}
</style>
